<main [ngClass]="{ 'oculto' : !alerts, 'elist' : alerts }">

  <div class="fixed-header" style="padding-left: 20px;">
    <h2 class="colorInge" style="font-weight: bold;">Pendientes</h2>
    <hr />
  </div>

  <div>
    <mat-tab-group>
      <mat-tab *ngIf="permisonViewNotification('ViewMinutesNotifications')">

        <ng-template mat-tab-label class="fixed-header">
          <mat-icon>text_snippet</mat-icon> &nbsp;&nbsp;
          <span matBadge="{{notificationsRecivedCountPending.countPendingMinutes}}" [matBadgeHidden]="notificationsRecivedCountPending.countPendingMinutes === 0" matBadgeOverlap="false" class="custom-badge">Minutas</span>
        </ng-template>

        <div class="scrollable-content" *ngIf="alertsMinute.length > 0; else noAlerts">
          <div *ngFor="let item of alertsMinute" class="card" (click)="redirectMinute(item)">
            <span class="card-text title_accion">{{ item.action }} N°{{ item.idType }}</span>
            <span class="card-text">{{ item.companyName }}</span>
            <span class="card-text">{{ item.date | date: 'dd/MM/yyyy' : '+0300' }} ({{ item.date | date: 'shortTime' : '-0600' }} hrs)</span>
          </div>

          <button
          *ngIf="notificationsRecivedCountPending.countPendingMinutes > 15"
          mat-flat-button
          color="primary"
          style="width: 100%; background-color: #003c8a; margin-top: 4px;"
          (click)="loadMoreMinutes()"
        >
          Mostrar más...
        </button>

        </div>

      </mat-tab>
      <mat-tab *ngIf="permisonViewNotification('ViewQuotesNotifications')">
        <ng-template mat-tab-label class="fixed-header">
          <mat-icon>sell</mat-icon> &nbsp;&nbsp;
          <span matBadge="{{notificationsRecivedCountPending.countPendingQuotes}}" [matBadgeHidden]="notificationsRecivedCountPending.countPendingQuotes === 0" matBadgeOverlap="false">Cotizaciones</span>
        </ng-template>
        
        <div class="scrollable-content tab" *ngIf="alertsDiscount.length > 0; else noAlerts">
          <div class="cards-container">
            <div *ngFor="let item of alertsDiscount" class="card" (click)="redirectDiscount(item)">
              <span class="card-text title_accion">{{ item.action }}</span>
              <span class="card-text">{{ item.companyName }}</span>
              <span class="card-text" [ngClass]="{'discount-class': item.discountPorcent > 0, 'aument-class': item.discountPorcent < 0}">
                <mat-icon 
                [ngClass]="{'positive-icon': item.discountPorcent >= 0, 'negative-icon': item.discountPorcent < 0}">
                {{ item.discountPorcent >= 0 ? 'arrow_downward' : 'arrow_upward' }}
                </mat-icon>
                {{ (item.discountPorcent * 100) | number:'1.0-2' }}%</span>
              <span class="card-text">{{ item.date | date: 'dd/MM/yyyy' : '+0300' }} ({{ item.date | date: 'shortTime' : '-0600' }} hrs)</span>
            </div>
          </div>
          
        </div>

      </mat-tab>
    </mat-tab-group>
  </div>

</main>

<ng-template #noAlerts>
  <br>
  <div style="text-align: center; align-content: center;">
    <strong>No hay Pendientes.</strong>
  </div>
</ng-template>